import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#0055B8', // Brand Blue (Pantone 2935 C)
      light: '#6DABE4', // Light Blue (Pantone 284 C)
      dark: '#003d85',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#6DABE4', // Light Blue
      light: '#A8CEEF',
      dark: '#4A90D9',
      contrastText: '#0055B8'
    },
    background: {
      default: '#FAFBFF', // Very light blue tint
      paper: '#FFFFFF'
    },
    text: {
      primary: '#1A2332', // Dark blue-gray
      secondary: '#4A5568' // Medium blue-gray
    },
    grey: {
      50: '#F8FAFF',
      100: '#F1F5FF',
      200: '#E2E8F0',
      300: '#CBD5E0',
      400: '#A0AEC0',
      500: '#718096',
      600: '#4A5568',
      700: '#2D3748',
      800: '#1A202C',
      900: '#1A2332',
    }
  },
  typography: {
    fontFamily: [
      '"IBM Plex Sans Thai"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '3.5rem',
      fontWeight: 300,
      lineHeight: 1.1,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 300,
      lineHeight: 1.2,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 400,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.75rem',
      fontWeight: 400,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
      fontWeight: 400,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
      fontWeight: 400,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    }
  },
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          padding: '12px 24px',
          fontSize: '0.875rem',
          fontWeight: 500,
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 8px rgba(0, 85, 184, 0.15)',
          },
        },
        contained: {
          background: 'linear-gradient(135deg, #0055B8 0%, #6DABE4 100%)',
          color: 'white',
          border: 'none',
          '&:hover': {
            background: 'linear-gradient(135deg, #003d85 0%, #4A90D9 100%)',
          },
        },
        outlined: {
          borderColor: '#0055B8',
          color: '#0055B8',
          '&:hover': {
            borderColor: '#003d85',
            backgroundColor: 'rgba(0, 85, 184, 0.04)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(26, 35, 50, 0.08)',
          border: '1px solid #E2E8F0',
          backgroundColor: '#FFFFFF',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 85, 184, 0.1)',
            transform: 'translateY(-2px)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          boxShadow: '0 1px 3px rgba(26, 35, 50, 0.06)',
          borderBottom: '1px solid rgba(226, 232, 240, 0.8)',
          color: '#1A2332',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          fontWeight: 500,
        },
        filled: {
          backgroundColor: '#F1F5FF',
          color: '#0055B8',
          border: '1px solid #6DABE4',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            '& fieldset': {
              borderColor: '#E2E8F0',
            },
            '&:hover fieldset': {
              borderColor: '#6DABE4',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#0055B8',
              borderWidth: '2px',
            },
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: '24px',
          paddingRight: '24px',
          '@media (min-width: 600px)': {
            paddingLeft: '32px',
            paddingRight: '32px',
          },
        },
      },
    },
  },
});